import { useEffect, useRef, useState } from "react";
import LoadingIcon from "../LoadingIcon";
import PrimaryButton from "./PrimaryButton";

/* Do NOT use this component - use ContainedButton instead from docs */
export default function LoadingPrimaryButton({
  children,
  size = "medium",
  ...props
}) {
  const [isLoading, setIsLoading] = useState(false);
  const componentRef = useRef(null);
  const initialWidthRef = useRef(null);

  const { onClick, disabled, ...restProps } = props;

  useEffect(() => {
    if (componentRef.current) {
      initialWidthRef.current =
        componentRef.current.getBoundingClientRect().width;
    }
  }, []);

  const handleClick = async () => {
    if (!onClick) return;

    setIsLoading(true);
    try {
      await onClick();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div ref={componentRef} style={{ display: "inline-block" }}>
      <PrimaryButton
        size={size}
        onClick={handleClick}
        disabled={isLoading || props.disabled}
        sx={{ width: isLoading ? `${initialWidthRef.current}px` : "auto" }}
        {...restProps}
      >
        {isLoading ? <LoadingIcon size={8} /> : children}
      </PrimaryButton>
    </div>
  );
}
